
import { useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(ScrollTrigger);

export default function BlogText() {
    const containerRef = useRef(null);
    const textRef = useRef(null);
    const titleRef = useRef(null);

    // Add animations when text comes into view
    useGSAP(() => {
        // Set initial state - invisible
        gsap.set([textRef.current, titleRef.current], {
            opacity: 0,
            y: 30
        });

        // Create timeline for coordinated animations
        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: containerRef.current,
                start: "80% 100%",
                toggleActions: "play none none reverse"
            }
        });

        // Animate paragraph
        timeline.to(textRef.current, {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: "power3.out"
        }, 0);

        // Animate title with delay
        timeline.to(titleRef.current, {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: "power3.out"
        }, 0.2);
    }, []);
    
    return (
        <>
            <div ref={containerRef} className="absolute bg-purple-card w-full h-[12rem] lg:h-[14rem] rounded-xl pl-[7.5%] pt-[3rem] md:pt-[4rem] text-white-text">
                <p ref={textRef} className="text-gray-nav uppercase">About me</p>
                <h2 ref={titleRef} className="mt-[1rem] text-[2.75rem] md:text-[3.75rem]">Who am I.</h2>
            </div>
        </>
    )
}

